<template>
  <section class="home-footer">
    <div class="home-footer-wrap">
      <el-row>
        <el-col
          class="home-footer-logo"
          :xs="24"
          :sm="24"
          :md="5"
          :lg="5"
          :xl="5"
        >
<!--          <router-link to="home"><img :src="pic1" alt="" />YUNKA </router-link>-->
          <router-link to="home">{{ contactConfig.brand.name }} </router-link>
        </el-col>
        <el-col class="nav" :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
          <div class="home-footer-nav">
            <router-link to="home">首页</router-link>
            <router-link to="buy"> 购买</router-link>
            <router-link to="comments">用户评论</router-link>
            <router-link to="contact">联系我们</router-link>
          </div>
          <div class="home-footer-copy" style="color: rgb(244, 244, 244);">
            © 2023  Studio. All rights reserved.
          </div>
        </el-col>
        <el-col class="pic" :xs="24" :sm="24" :md="3" :lg="3" :xl="3">
          <el-link :href="contactConfig.telegram.url" target="_blank">
            <svg
              t="1650121837944"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="49558"
              width="18"
              height="18"
            >
              <path
                d="M385.20448 889.045333c-30.464 0-25.301333-11.562667-35.797333-40.490666l-89.728-295.253334L949.897813 143.786667"
                fill="#aeb0b5"
                p-id="49559"
              ></path>
              <path
                d="M385.20448 889.045333c23.552 0 33.92-10.752 47.146667-23.594666l125.482666-121.898667-156.629333-94.464"
                fill="#aeb0b5"
                p-id="49560"
              ></path>
              <path
                d="M401.20448 649.088l379.306667 280.234667c43.306667 23.893333 74.581333 11.562667 85.333333-40.192l154.453333-727.594667c15.872-63.445333-24.064-92.117333-65.450666-73.386667L48.009813 437.888c-61.866667 24.832-61.568 59.392-11.264 74.794667l232.746667 72.533333L808.11648 245.461333c25.386667-15.36 48.768-7.125333 29.610667 9.898667"
                fill="#aeb0b5"
                p-id="49561"
              ></path></svg
          ></el-link>
        </el-col>
      </el-row>
    </div>
  </section>
</template>

<script>
import contactConfig from "@/config/contact";

export default {
  data() {
    return {
      contactConfig
    };
  }
};
</script>

<style lang="less" scoped>
.home-footer {
//   position: absolute;
//   bottom: 0;
//   width: 100%;
//   background-color: rgba(14, 4, 27, 0.5);
  .home-footer-wrap {
    width: 80%;
    margin: 0 auto;
    padding: 58px 20px 36px 20px;
    .home-footer-logo {
      font-size: 24px;
      opacity: 0.6;
      height: 40px;
      line-height: 40px;
      margin-bottom: 20px;
      text-align: center;
      padding-bottom: 20px;

      img {
        height: 26px;
        position: relative;
        top: 3px;
        margin-right: 12px;
      }
    }
    .nav {
      color: rgb(142, 129, 158);
      text-align: center;
      padding-bottom: 20px;
      .home-footer-copy {
        margin-top: 26px;
        font-size: 12px;
      }

      .home-footer-copy {
        margin-top: 26px;
        font-size: 12px;
        color: rgb(244, 244, 244);
      }
    }
    .pic {
      padding-bottom: 20px;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue